import { AppProvider } from '../../contexts/AppContext'
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import UsersList from "../pages/lgpd/UsersList";
import theme from "../theme";
import DashboardInd from '../pages/industrial/Dashboard'
import Dashboard from '../pages/office/Dashboard'

const Application = () => (
    <ThemeProvider theme={theme}>
        <AppProvider>
            <Router>
                <Routes>
                    <Route exact path="/:accessToken?" element={<UsersList />} />
                    <Route exact path="/lgpd/:accessToken?" element={<UsersList />} />
                    <Route exact path="/office/:officeId/dashboard/:accessToken?" element={<Dashboard />} />
                    <Route exact path="/industrial/:industrialId/dashboard/:accessToken?" element={<DashboardInd />} />
                </Routes>
            </Router>
        </AppProvider>
    </ThemeProvider>
)

export default Application